/**
 * Stable identifier for a vehicle, derived from its natural identity
 * fields. Same vehicle → same key across page loads, refreshes, tabs.
 *
 * Used as `ActiveVehicle.id` so that:
 *   - Refresh dedupe in the backend (TRAC-527 follow-up) sees the same
 *     vehicleId across page loads instead of a per-load random handle.
 *   - Click ↔ impression correlation by vehicleId works across refreshes.
 *   - React keys remain stable for the same logical vehicle.
 *
 * Uniqueness is guaranteed by `isSameVehicle` upstream in
 * ChatInterface.upsertVehicle — two ActiveVehicles with the same key
 * are merged into one entry, so React keys never collide.
 */
export function vehicleIdentityKey(
  year: number,
  make: string,
  model: string,
  variant?: string,
): string {
  return [year, make, model, variant ?? '']
    .join('|')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-');
}
